import { render, staticRenderFns } from "./entity-form-basic.vue?vue&type=template&id=041577aa&"
import script from "./entity-form-basic.vue?vue&type=script&lang=js&"
export * from "./entity-form-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports